declare global {
  interface Window { env: any }
}

export const environment = {
  actedArchivesCommitSha: window.env?.ACTED_ARCHIVES_COMMIT_SHA || '',
  production: window.env?.PRODUCTION.toLowerCase() === 'true',
  apiRoot: window.env?.API_BACKEND_URL || 'http://localhost:8000',
  serviceWorkerEnabled: window.env?.SERVICE_WORKER_ENABLED.toLowerCase() === 'true',
  checkUpdatesInterval: parseInt(window.env?.CHECK_UPDATES_INTERVAL),
  ssoClientId: window.env?.SSO_CLIENT_ID,
  // comma-separated list of API origins; turned into a protected resource map in @app/auth/msal.providers
  ssoAllowedOrigins: window.env?.SSO_ALLOWED_ORIGINS,
  ssoTenantId: window.env?.SSO_TENANT_ID,
  pdfTronLicenseKey: window.env?.PDF_TRON_LICENSE_KEY,
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
